import { IconDefaultType } from "@slhuiicon/icon-core";

const HINT_ICON_TYPE = IconDefaultType.ICO_INFO;
const ERROR_ICON_TYPE = IconDefaultType.ICO_MISSINGINFO;
const ICON_SIZE_SMALL = 16;

export { HINT_ICON_TYPE, ERROR_ICON_TYPE, ICON_SIZE_SMALL };
